import { Router, Route, Switch } from 'wouter'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { Toaster } from '@/components/ui/toaster'
import { ThemeProvider } from '@/components/theme-provider'
import { Header } from '@/components/layout/header'
import { Button } from '@/components/ui/button'
import Footer from '@/components/Footer'
import HomePage from '@/pages/HomePage'
import UploadPage from '@/pages/UploadPage'
import ResultsPage from '@/pages/ResultsPage'
import DashboardPage from '@/pages/DashboardPage'
import { useLocation } from 'wouter'

// Create a client with default options
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000, // 5 minutes
      retry: 1,
    },
  },
})

function AppLayout({ children }) {
  const [location] = useLocation()
  const showHeader = !['/'].includes(location) // Hide header on home page for cleaner hero

  return (
    <div className="min-h-screen bg-background text-foreground flex flex-col">
      {showHeader && <Header />}
      <main className="flex-1">
        {children}
      </main>
      <Footer />
    </div>
  )
}

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <ThemeProvider defaultTheme="light" storageKey="lease-extraction-theme">
        <Router>
          <AppLayout>
            <Switch>
              <Route path="/" component={HomePage} />
              <Route path="/upload" component={UploadPage} />
              <Route path="/results/:jobId" component={ResultsPage} />
              <Route path="/dashboard/:jobId" component={DashboardPage} />
              <Route component={() => (
                <div className="min-h-screen flex items-center justify-center">
                  <div className="text-center">
                    <h1 className="text-4xl font-bold text-gray-900 dark:text-white mb-4">404</h1>
                    <p className="text-gray-600 dark:text-gray-300 mb-4">Page not found</p>
                    <Button onClick={() => window.location.href = '/'}>Go Home</Button>
                  </div>
                </div>
              )} />
            </Switch>
          </AppLayout>
          <Toaster />
        </Router>
      </ThemeProvider>
    </QueryClientProvider>
  )
}

export default App